import React,{ useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch/* TODO after PILOT , useSelector*/ } from "react-redux";
import { useLocation } from "react-router-dom";
import { getPrecogFiscalPayment, clearPrecogFiscalPayment } from "../../../../store/actions/precog/fiscalPayments";
// TODO after PILOT import AdvancePaymentsTable from "./advancePaymentsTable";
// TODO after PILOT import InvoiceToAdvanceTable from "./invoiceToAdvanceTable";
import NewRecordForm from "./newRecordForm";

import "./style.css";

const FiscalPayments = ({newDetail, reasonsBankActive, createReason, totalInvoice}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  // TODO after PILOT const source = useSelector(state => state.precog.invoiceDetail?.data?.source);
  // TODO after PILOT let reasonId = useSelector(state => state.precog?.invoiceDetail?.data?.reasonId);
  // TODO after PILOT reasonId = createReason ? createReason : reasonId;
  const [totalSelection/* , TODO after PILOT setTotalSelection*/] = useState(0);
  const draftId = location.pathname.split("/")[2];
  // se sto creando il reasonId arriva dalla scelta in modale e non dal redux

  useEffect(() => {
    /** Nel caso di nuova registrazione il draftId non è registrato in redux */
    const currentDraft = draftId || newDetail?.id;
    dispatch(getPrecogFiscalPayment(currentDraft));
    return () => {
      dispatch(clearPrecogFiscalPayment());
    };
  }, [draftId]);
  
  return (
    <div className="receiptsPayment_container">

      { /** il titolo varia in base a se stai registrando fatture o pagamenti/incassi 
       * LATO Test hanno lamentato l'assenza della form quindi evitiamo di controllare reasonsBankActive. Tutti possono vedere
        reasonsBankActive.includes(reasonId) &&
          <span className="bluTitle">
            <FormattedMessage id="preCog.fiscalPayments.titleRegister"/>
          </span>
          */
      }
      {
        newDetail?.hasContextualPayment &&
      <>
        <span className="bluTitle">
          <FormattedMessage id="preCog.fiscalPayments.titleRegister"/>
        </span>

        { /** La form solo in caso di registrazione fatture, no pagamenti/incassi
          reasonsBankActive.includes(reasonId) &&
          <NewRecordForm draftId={draftId || newDetail?.id} totalSelection={totalSelection} totalInvoice={totalInvoice} />
          */
        }
        <NewRecordForm draftId={draftId || newDetail?.id} totalSelection={totalSelection} totalInvoice={totalInvoice} />
      </>
      }
      {/** Solo se ci sono già degli acconti registrati viene mostrata la tabella 
       * TODO Temporary hidden to PILOT purpose
      <div>
        {
          (source !== "MANUAL" && reasonsBankActive?.includes(reasonId) ) ?
            <span className="bluTitle">
              <FormattedMessage id="preCog.fiscalPayments.titleInvoice1"/>
              <FormattedMessage id="preCog.fiscalPayments.titleInvoice2"/>
            </span> :
            <span className="bluTitle"><FormattedMessage id="preCog.fiscalPayments.titleAssociate"/></span>
        }

        <div>
          <FormattedMessage
            id={source === "MANUAL" || reasonsBankActive?.includes(reasonId) ? "preCog.fiscalPayments.subtitleTableInvoices" : "preCog.fiscalPayments.subtitleTableAdvances"}/>
        </div>
        {
          (source !== "MANUAL" && reasonsBankActive?.includes(reasonId)) ?
            <InvoiceToAdvanceTable draftId={draftId || newDetail?.id} newDetail={newDetail} />
            :
            <AdvancePaymentsTable draftId={draftId || newDetail?.id} newDetail={newDetail} setTotalSelection={setTotalSelection} />
        }
      </div>
    */}
    </div>
  );
};

export default FiscalPayments;
